<template>
    <v-card>
        <v-card-text>
            <v-form ref="form" v-model="validForm">
                <v-row>
                    <v-col>
                        <v-text-field dense id="name" label="Nome completo" v-model="dataset.data.name" required
                            :rules="[$rules.required]" outlined hide-details="auto"
                            @blur="dataset.data.name = (dataset.data.name || '').trim()">
                        </v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col>
                        <v-text-field dense id="registration"
                            :label="dataset.data.is_foreign ? 'Identificação' : 'CPF/CNPJ'"
                            v-model="dataset.data.registration" required
                            v-mask="dataset.data.is_foreign ? null : dataset.data.registration && dataset.data.registration.length < 15 ? this.$masks.cpf : this.$masks.cnpj"
                            :rules="[$rules.required, (dataset.data.is_foreign ? null : dataset.data.registration && dataset.data.registration.length < 15 ? $rules.cpf : $rules.cnpj)]"
                            outlined hide-details="auto"
                            @blur="dataset.data.registration = (dataset.data.registration || '').trim()">
                        </v-text-field>
                    </v-col>
                </v-row>

                <v-row no-gutters class="mb-4">
                    <v-col class="d-flex align-center">
                        <v-checkbox v-model="dataset.data.is_foreign" label="Estrangeiro" hide-details="auto">
                        </v-checkbox>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon class="mt-5 ml-3" small :color="'primary'" v-bind="attrs"
                                    v-on="on">mdi-help-circle</v-icon>
                            </template>
                            <span>Caso o documento seja diferente de CPF/CNPJ, selecione essa opção.</span>
                        </v-tooltip>
                    </v-col>
                </v-row>

                <v-row v-if="isCNPJ">
                    <v-col>
                        <strong>Representante(s)</strong>
                    </v-col>
                </v-row>

                <template v-if="isCNPJ">
                    <v-card v-for="(rep, index) in dataset.data.representatives" :key="index" outlined class="mb-2">
                        <v-card-title class="py-2 d-flex justify-space-between align-center">
                            <span class="subtitle-2">Representante - {{ index + 1 }}</span>

                            <v-btn icon color="red" v-if="dataset.data.representatives.length > 1"
                                @click="removeRepresentative(index)" title="Remover representante">
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </v-card-title>

                        <v-divider />

                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field dense label="Nome do representante" v-model="rep.name"
                                        :rules="[$rules.required]" outlined hide-details="auto" />
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12">
                                    <v-text-field dense class="mb-2" id="email" label="E-mail do representante"
                                        v-model="rep.email" required :rules="[$rules.required, $rules.email]" outlined
                                        hide-details="auto">
                                    </v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12">
                                    <v-text-field dense label="CPF do representante" v-model="rep.registration"
                                        :rules="[$rules.required, $rules.cpf]" outlined hide-details="auto"
                                        v-mask="['###.###.###-##']" />
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12">
                                    <v-file-input dense accept="image/png, image/jpeg, application/pdf" outlined
                                        prepend-icon="" :rules="[$rules.required, $rules.fileSize(4)]"
                                        truncate-length="70" show-size counter required
                                        hint="O arquivo não pode ser superior a 4MB" label="Documento de identificação"
                                        hide-details="auto" @change="onRepresentativeFileSelected($event, index)" />
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </template>

                <v-row v-if="isCNPJ">
                    <v-col>
                        <v-btn small outlined color="primary" @click="addRepresentative">
                            <v-icon left>mdi-plus</v-icon>
                            Adicionar representante
                        </v-btn>
                    </v-col>
                </v-row>


                <!-- <v-row v-if="isCNPJ">
                    <v-col>
                        <v-text-field dense id="representative" label="Nome representante"
                            v-model="dataset.data.representative_name" required :rules="[$rules.required]" outlined
                            hide-details="auto">
                        </v-text-field>
                    </v-col>
                </v-row> -->

                <!-- <v-row v-if="isCNPJ">
                    <v-col>
                        <v-text-field dense id="representative_registration" label="CPF representante"
                            v-model="dataset.data.representative_registration" required :rules="[$rules.required]" outlined
                            hide-details="auto" v-mask="dataset.data.representative_registration && dataset.data.representative_registration.length < 15 ? this.$masks.cpf : this.$masks.cnpj">
                        </v-text-field>
                    </v-col>
                </v-row> -->

                <!-- <v-row v-if="isCNPJ">
                    <v-col>
                        <v-file-input dense accept="image/png, image/jpeg, application/pdf" prepend-icon="" outlined
                            counter required :rules="[$rules.required, $rules.fileSize(4)]" show-size
                            hint="O arquivo não pode ser superior a 4MB" hide-details="auto"
                            label="Documento representante"
                            :clearable="true" @change="onRepresentativeFileSelected($event)" ref="representative_file">
                        </v-file-input>
                    </v-col>
                </v-row> -->

                <v-row v-if="isCNPJ">
                    <v-col>
                        <v-file-input dense accept="image/png, image/jpeg, application/pdf" prepend-icon="" outlined
                            counter :rules="[fileSize]" show-size multiple
                            hint="Cada arquivo não pode ser superior a 4MB" hide-details="auto"
                            label="Outros documentos" v-model="dataset.data.company_other_files" :clearable="true"
                            @change="onCompanyOtherFiles($event)" ref="other_files">
                            <template v-slot:selection="{ text, index }">
                                <v-chip small label color="primary" class="ma-1">
                                    {{ dataset.data.company_other_files[index].name }}
                                </v-chip>
                            </template>

                        </v-file-input>
                    </v-col>
                </v-row>

                <v-row no-gutters class="mb-1" v-if="isCNPJ">
                    <v-col class="d-flex align-center">
                        <v-checkbox v-if="isCNPJ" v-model="dataset.data.is_me_epp" label="ME/EPP" hide-details="auto">
                        </v-checkbox>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon class="mt-5 ml-3" small :color="'primary'" v-bind="attrs"
                                    v-on="on">mdi-help-circle</v-icon>
                            </template>
                            <span>Caso a empresa se enquadre como microempresa ou empresa de pequeno porte, marque esta
                                opção.</span>
                        </v-tooltip>
                    </v-col>
                </v-row>

                <v-row v-if="isCNPJ" no-gutters class="mb-2">
                    <v-col class="d-flex align-center">
                        <v-checkbox v-model="dataset.data.is_financial_institution" label="Instituição financeira" hide-details="auto">
                        </v-checkbox>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon class="mt-5 ml-3" small :color="'primary'" v-bind="attrs"
                                    v-on="on">mdi-help-circle</v-icon>
                            </template>
                            <span>Caso o cadastro for de uma instituição financeira, selecione essa opção.</span>
                        </v-tooltip>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col>
                        <v-text-field dense label="Celular" v-model="dataset.data.phone_number" required
                            :rules="[$rules.required]" outlined hide-details="auto"
                            @blur="dataset.data.phone_number = (dataset.data.phone_number || '').trim()">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field dense class="mb-2" id="email" label="E-mail" v-model="dataset.data.email" required
                            :rules="[$rules.required, $rules.email]" outlined hide-details="auto"
                            @blur="dataset.data.email = (dataset.data.email || '').trim()">
                        </v-text-field>
                        <span class="important-text">
                            * De preferência, crie este cadastro com o mesmo e-mail utilizado no site da 123
                            Milhas/Hotmilhas,
                            em
                            que recebeu o comprovante de pagamento da sua compra e/ou venda
                        </span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field dense outlined label="Senha"
                            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" required
                            :rules="[$rules.required, $rules.strongPassword]" :type="showPassword ? 'text' : 'password'"
                            v-model="dataset.data.password" @click:append="showPassword = !showPassword"
                            hide-details="auto" id="password"
                            @blur="dataset.data.password = (dataset.data.password || '').trim()">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-file-input dense accept="image/png, image/jpeg, application/pdf" prepend-icon="" outlined
                            counter required :rules="[$rules.required, $rules.fileSize(4)]" show-size
                            hint="O arquivo não pode ser superior a 4MB" hide-details="auto"
                            label="Documento de identificação (CPF, RG ou CNH / Contrato Social e Procuração)"
                            :clearable="true" @change="onFileSelected($event)" ref="logoFile">
                        </v-file-input>
                    </v-col>
                </v-row>

                <!-- <v-row align="center">
                    <v-col cols="auto">
                        <span><strong>Possui procurador?</strong></span>
                    </v-col>
                    <v-col cols="auto">
                        <v-radio-group v-model="procuratorQuestion" row>
                            <v-radio label="Sim" :value="true"></v-radio>
                            <v-radio label="Não" :value="false"></v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row> -->

                <template v-if="procuratorQuestion">

                    <v-row>
                        <v-col>
                            <v-text-field dense id="procurator_name" label="Nome procurador"
                                v-model="dataset.data.procurator_name" required :rules="[$rules.required]" outlined
                                hide-details="auto">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field dense id="procurator_registration" label="CPF"
                                v-model="dataset.data.procurator_registration" required
                                :rules="[$rules.required, $rules.cpf]" outlined hide-details="auto"
                                v-mask="['###.###.###-##']">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field dense id="procurator_federal_registration" label="Número OAB"
                                v-model="dataset.data.procurator_federal_registration" required
                                :rules="[$rules.required, $rules.alphaNumeric]" outlined hide-details="auto">
                            </v-text-field>
                        </v-col>
                        <v-col>
                            <v-autocomplete :disabled="dataset.loading" dense required :items="dataset.statesList"
                                label="OAB UF" v-model="dataset.data.procurator_federal_registration_uf"
                                item-value="name" item-text="name" :rules="[$rules.required]" outlined
                                hide-details="auto">
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field dense id="procurator_email" label="E-mail"
                                v-model="dataset.data.procurator_email" required :rules="[$rules.required]" outlined
                                hide-details="auto">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-file-input dense accept="image/png, image/jpeg, application/pdf" prepend-icon="" outlined
                                counter required :rules="[$rules.required, $rules.fileSize(4)]" show-size
                                hint="O arquivo não pode ser superior a 4MB" hide-details="auto" label="Documento OAB"
                                :clearable="true" @change="onProcuratorSelected($event)" ref="procurator_file">
                            </v-file-input>

                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-file-input dense accept="image/png, image/jpeg, application/pdf" prepend-icon="" outlined
                                counter required :rules="[$rules.required, $rules.fileSize(4)]" show-size
                                hint="O arquivo não pode ser superior a 4MB" hide-details="auto"
                                label="Documento procuração" :clearable="true" @change="onProcurationSelected($event)"
                                ref="procuration_file">
                            </v-file-input>

                        </v-col>
                    </v-row>
                </template>

                <br>

                <v-row no-gutters class="mb-4">
                    <v-col>
                        <v-btn-toggle v-model="selectedDocument" mandatory color="primary" class="mb-4" dense>
                            <v-btn value="terms" small>Termos de Uso</v-btn>
                            <v-btn value="privacy" small>Política de Privacidade</v-btn>
                        </v-btn-toggle>

                        <div class="mb-4">
                            <v-btn small text color="primary" class="mr-2" @click="downloadPdf">
                                Baixar {{ selectedDocument === 'terms' ? 'Termos de Uso' : 'Política de Privacidade' }}
                            </v-btn>
                        </div>

                        <div v-if="isMobile">
                            <!-- Para celular: usa Google Docs Viewer -->
                            <iframe :src="googleDocsViewerUrl" width="100%" height="600px" frameborder="0"
                                @error="pdfLoadError = true"></iframe>
                        </div>
                        <div v-else>
                            <!-- Para desktop: usa iframe nativo -->
                            <iframe :src="pdfUrl + '#toolbar=0&navpanes=0&scrollbar=0'" width="100%" height="400px"
                                style="overflow: hidden;" frameborder="0" @error="pdfLoadError = true"></iframe>
                        </div>
                        <span v-if="pdfLoadError" class="error-text">Erro ao carregar documento de privacidade.</span>

                        <br>
                        <br>
                        <v-checkbox :rules="[$rules.required]" v-model="dataset.data.terms" class="mt-0">
                            <template v-slot:label>
                                <span>
                                    Eu li e concordo com os Termos de Uso e a Política de Privacidade
                                </span>
                            </template>
                        </v-checkbox>
                        <span class="important-text">
                            * Ao aceitar você estará ciente das práticas de coleta, uso, e divulgação de informações
                            pessoais descritas nas políticas mencionadas, e autorizo o processamento dos meus dados
                            de acordo com tais termos.
                        </span>

                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
        <v-card-text>
            <v-btn color="primary" @click.native="create" :loading="loading">Finalizar</v-btn>
            <v-btn color="grey" text @click.native="goBack">Cancelar</v-btn>
        </v-card-text>
    </v-card>
</template>

<script>
import 'moment/locale/pt-br';
import statesList from "@/common/data/states-list.data";

import { eventHub } from "@/main";

import axios from "axios"

import string from "@/common/util/string"

export default {
    data: () => ({
        showPassword: false,
        validForm: false,
        loading: false,
        procuratorQuestion: false,
        selectedDocument: 'terms',
        pdfLoadError: false,
        termFiles: [],
        dataset: {
            data: {
                is_me_epp: false,
                terms: false,
                company_other_files: [],
                representatives: [],
            },
            statesList: statesList,
        },

    }),

    mounted: function () {
        this.loadTerms();
    },

    created() {
    },

    watch: {
        isCNPJ(newValue) {
            if (!Array.isArray(this.dataset.data.representatives)) {
                this.$set(this.dataset.data, 'representatives', []);
            }

            if (newValue && this.dataset.data.representatives.length === 0) {
                this.addRepresentative();
            }

            if (!newValue) {
                this.dataset.data.representatives = [];
            }
        }
    },

    computed: {
        // getMask() {
        //     return
        // }
        pdfUrl() {
            const doc = this.termFiles.find(d => d.document_type === this.selectedDocument);
            return doc ? doc.s3_url : '';
        },

        downloadFileName() {
            const doc = this.termFiles.find(d => d.document_type === this.selectedDocument);
            return this.selectedDocument === 'terms'
                ? `termos_de_uso_v${doc.version || ''}.pdf`
                : `privacidade_v${doc.version || ''}.pdf`;
        },

        googleDocsViewerUrl() {
            if (!this.pdfUrl) {
                return '';
            }
            const encodedUrl = encodeURIComponent(this.pdfUrl);
            const viewerUrl = `https://docs.google.com/viewer?url=${encodedUrl}&embedded=true`;
            return viewerUrl;
        },

        isMobile() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        },

        isCNPJ() {
           // return !this.dataset.data.is_foreign && this.dataset.data.registration && this.dataset.data.registration.length >= 18;

            const registration = this.dataset.data.registration || '';
            return !this.dataset.data.is_foreign && registration.replace(/\D/g, '').length === 14;
        },

    },

    methods: {
        onFileSelected(file) {
            this.dataset.data.file = file;
        },

        onProcurationSelected(procuration_file) {
            this.dataset.data.procuration_file = procuration_file;
        },

        onProcuratorSelected(procurator_file) {
            this.dataset.data.procurator_file = procurator_file;
        },

       
        onRepresentativeFileSelected(file, index) {
            if (!file) return;
            this.$set(this.dataset.data.representatives[index], 'file', file);
        },
        

        // onRepresentativeFileSelected(file, index) {
        //     this.dataset.data.representatives[index].file = file
        // },


        onCompanyOtherFiles(files) {
            this.dataset.data.company_other_files = files.filter(file => file.size <= 4 * 1024 * 1024);
        },

        fileSize(value) {
            if (!value || value.length === 0) return true;
            const invalid = value.find(file => file.size > 4 * 1024 * 1024);
            return !invalid || 'Cada arquivo deve ter no máximo 4MB';
        },

        openPdf(pdfPath) {
            window.open(`${window.location.origin}${pdfPath}`, '_blank');
        },

        async create() {

            if (!this.$refs.form.validate()) return;

            if (!this.dataset.data.terms) {
                this.$dialog.notify.error("Por favor, leia e aceite nossos Termos de Uso e Política de Privacidade para prosseguir!", {
                    position: "top-right",
                    timeout: 3000,
                });

                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja finalizar o cadastro?',
                title: 'Cadastro',
                actions: {
                    false: 'Cancelar',
                    true: 'Finalizar'
                }
            })

            if (!proceedAction) return;

            this.loading = true;

            const payload = this.buildPayload();

            try {
                await axios.post('/api/users', payload);

                await this.$dialog.confirm({
                    text: 'Cadastro realizado com sucesso! Um e-mail foi enviado para a sua caixa de entrada, acesse-o para verificar sua conta.',
                    title: 'Sucesso',
                    actions: {
                        true: 'OK'
                    }
                })

                this.goBack()
            } catch (error) {
                if (error && error.response && error.response.data.content) {
                    const errorTmp = error.response.data.content.error;
                    if (errorTmp.code == 1032) {
                        this.$dialog.confirm({
                            text: 'Seu CPF/CPNJ foi vinculado a mais de um nome na lista de credores. Seu pedido de habilitação/divergência foi registrado, mas deverá ser complementado. A Administração Judicial entrará em contato por e-mail com instruções sobre como prosseguir.',
                            title: 'Atenção',
                            actions: {
                                true: 'OK'
                            }
                        })
                    }
                }
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.loading = false;
            }

        },

        goBack() {
            this.dataset.data = {};
            eventHub.$emit('DIALOG-REGISTER', false)
        },

        buildPayload() {
            const formData = new FormData()

            formData.append('name', (this.dataset.data.name || '').trim());
            formData.append('registration', string.sanitizeCpfCnpj((this.dataset.data.registration || '').trim()).replaceAll(' ', ''));
            formData.append('phone_number', string.sanitizePhone((this.dataset.data.phone_number || '').trim()));
            formData.append('email', (this.dataset.data.email || '').trim());
            formData.append('password', (this.dataset.data.password || '').trim());
            formData.append('is_me_epp', this.dataset.data.is_me_epp);
            formData.append('is_foreign', this.dataset.data.is_foreign);
            formData.append('is_financial_institution', this.dataset.data.is_financial_institution);

            if (Array.isArray(this.dataset.data.representatives)) {
                this.dataset.data.representatives.forEach((rep, index) => {

                    if (rep.name) {
                        formData.append(
                            `representatives[${index}][name]`,
                            rep.name
                        );
                    }
   
                    if (rep.email) {
                        formData.append(
                            `representatives[${index}][email]`,
                            rep.email
                        );
                    }

                    if (rep.registration) {
                        const sanitized = string.sanitizeCpfCnpj(rep.registration) || '';
                        formData.append(
                            `representatives[${index}][registration]`,
                            sanitized.replace(/ /g, '')
                        );
                    }

                    if (rep.file instanceof File) {
                        formData.append('representatives_files[]', rep.file);
                        formData.append('representatives_order[]', index);
                    }

                });
            }

            if (Array.isArray(this.dataset.data.company_other_files)) {
                this.dataset.data.company_other_files.forEach(item => {
                    if (item instanceof File) {
                        formData.append("other_files[]", item);
                    }
                });
            }

            formData.append('terms', this.dataset.data.terms);

            const termFile = this.termFiles.find(item => item.document_type === "terms");
            if (termFile && termFile.resource_id) {
                formData.append('resource_id', termFile.resource_id);
            }

            formData.append('file', this.dataset.data.file)

            if (this.procuratorQuestion) {
                formData.append('procurator_name', this.dataset.data.procurator_name);
                formData.append('procurator_email', this.dataset.data.procurator_email);
                formData.append('procurator_federal_registration', this.dataset.data.procurator_federal_registration);
                formData.append('procurator_federal_registration_uf', this.dataset.data.procurator_federal_registration_uf);
                formData.append('procurator_file', this.dataset.data.procurator_file);
                formData.append('procuration_file', this.dataset.data.procuration_file);
                formData.append("procurator_registration", string.sanitizeCpfCnpj(this.dataset.data.registration));

            } else {
                formData.append('procurator_name', '');
                formData.append('procurator_registration', '');
                formData.append('procurator_email', '');
                formData.append('procurator_federal_registration', '');
                formData.append('procurator_federal_registration_uf', '');
                formData.append('procurator_file', '');
                formData.append('procuration_file', '');
            }
            return formData;
        },

        async loadTerms() {

            try {

                const result = await axios.get('/api/terms/updated-user');

                this.termFiles = result.data.content.data

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            }

        },

        async downloadPdf() {

            try {

                const doc = this.termFiles.find(d => d.document_type === this.selectedDocument);

                if (!doc || !doc.s3_url) {
                    throw new Error('Arquivo não encontrado');
                }

                window.open(doc.s3_url, '_blank', 'noopener,noreferrer');

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            }
        },

        addRepresentative() {
            const data = this.dataset && this.dataset.data
                ? this.dataset.data
                : (this.dataset.data = {})

            if (!Array.isArray(data.representatives)) {
                this.$set(data, 'representatives', [])
            }

            if (data.representatives.length >= 2) {
                this.$dialog.notify.warning('É permitido adicionar no máximo 2 representantes.')
                return
            }

            data.representatives.push({
                name: '',
                registration: '',
                file: null
            })
        },

        removeRepresentative(index) {
            this.dataset.data.representatives.splice(index, 1)
        },

    }
};
</script>

<style lang="scss">
.title-page {
    color: var(--v-primary-base);
    font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

p {
    text-align: justify;
}

.checkbox-link {
    color: #1976d2;
    text-decoration: none;
}

.checkbox-link:hover {
    text-decoration: underline;
}

.important-text {
    font-size: 12px;
    color: #757575;
}

.error-text {
    color: red;
    font-size: 14px;
}
</style>
